const _excluded = ["selectedColor"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import Icon from './Icon';
const TextColorIcon = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      selectedColor
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Icon, _extends({
    "data-testid": "textColor",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: selectedColor,
    d: "M20.985,21.5H3a1.5,1.5,0,1,1,0-3H20.985a1.5,1.5,0,0,1,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.026,15.248h-1.49l-1.98-5.11-2.87-7.41a.758.758,0,0,0-.7-.48.748.748,0,0,0-.7.48l-2.84,7.38a.108.108,0,0,0-.03.07l-1.96,5.07H4.966a.75.75,0,0,0,0,1.5h4a.75.75,0,0,0,0-1.5h-.91l1.58-4.07h4.72l1.57,4.07h-.9a.75.75,0,0,0,0,1.5h4a.75.75,0,0,0,0-1.5Zm-8.82-5.57,1.78-4.6,1.78,4.6Z"
  }));
});
TextColorIcon.displayName = 'TextColorIcon';
TextColorIcon.renderIcon = props => /*#__PURE__*/React.createElement(TextColorIcon, props);
export default TextColorIcon;
//# sourceMappingURL=TextColorIcon.js.map